/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { getEmployees, getEmployee, showModal } from "actions";
import PositionChange from "components/employeeManagement/PositionChange";
import JobTermination from "components/employeeManagement/JobTermination";
import UpdateEmployee from "components/employeeManagement/UpdateEmployee";
import CompanyTransfer from "components/employeeManagement/CompanyTransfer";
import ActivateEmployee from "./ActivateEmployee";
import ReActivateEmployee from "./ReActivateEmployee";

class Employee extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  componentDidMount() { }

  componentDidUpdate(prevProps, prevState) { }

  openPositionChangeModal = (employee) => {
    this.props.showModal({
      modalType: "positionChangeModal",
      modalTitle: i18n.t("10563"),
      modalContent: <PositionChange employee={employee} />,
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  };

  openCompanyTransferModal = (employee) => {
    this.props.showModal({
      modalType: "companyTransferModal",
      modalTitle: i18n.t("employeemanagement_company-transfer"),
      modalContent: <CompanyTransfer employee={employee} />,
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  };

  openJobTerminationModal = (employee) => {
    this.props.showModal({
      modalType: "jobTerminationModal",
      modalTitle: i18n.t("10564"),
      modalContent: <JobTermination employee={employee} />,
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  };

  openUpdateEmployeeModal = (employee) => {
    this.props.showModal({
      modalType: "updateEmployeeModal",
      modalTitle: i18n.t("10565"),
      modalContent: <UpdateEmployee employee={employee} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl",
    });
  };

  openActivateEmployeeModal = (employee) => {
    this.props.showModal({
      modalType: "activateEmployeeModal",
      modalTitle: i18n.t("10723"),
      modalContent: <ActivateEmployee employee={employee} />,
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  }

  openReActivateEmployeeModal = (employee) => {
    this.props.showModal({
      modalType: "activateEmployeeModal",
      modalTitle: i18n.t("reactive"),
      modalContent: <ReActivateEmployee employee={employee} employeelist={this.props.employeelist} />,
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTabletModeDetail = (employee) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Durum">10547</Trans>
                  </div>
                </td>
                <td className="showGrup">{employee.emailAddress}</td>
              </tr>
              <tr>
                <td className="tableTitle">
                  <Trans desc="Dil Tercihi">
                    employeemanagement_preferred-language
                  </Trans>
                </td>
                <td className="showGrup">{employee?.language?.label}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <Trans desc="Pozisyon Değişimi">10563</Trans>
                </td>
                <td>
                  <button
                    className="btn-action btn-blue"
                    onClick={() => this.openPositionChangeModal(employee)}
                  >
                    <Trans desc="Pozisyon Değişimi">10563</Trans>
                  </button>
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <Trans desc="Bayi Değişimi">
                    employeemanagement_company-transfer
                  </Trans>
                </td>
                <td>
                  <button
                    className="btn-action btn-orange"
                    onClick={() => this.openCompanyTransferModal(employee)}
                  >
                    <Trans desc="Pozisyon Değişimi">10563</Trans>
                  </button>
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <Trans desc="İşten Çıkış">10564</Trans>
                </td>
                <td>
                  <button
                    className="btn-action btn-red"
                    onClick={() => this.openJobTerminationModal(employee)}
                  >
                    <Trans desc="İşten Çıkış">10564</Trans>
                  </button>
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <Trans desc="Düzenleme">10565</Trans>
                </td>
                <td>
                  <button
                    className="btn-action btn-green"
                    onClick={() => this.openUpdateEmployeeModal(employee)}
                  >
                    <Trans desc="Düzenleme">10565</Trans>
                  </button>
                </td>
              </tr>
              {
                employee.exportAvailabilityCode?.value == 2 ?
                  <tr data-dt-row="0" data-dt-column="2">
                    <td>
                      <Trans desc="Aktifleştir">10723</Trans>
                    </td>
                    <td>
                      <button
                        className="btn-action btn-brown"
                        onClick={() => this.openActivateEmployeeModal(employee)}
                      >
                        <Trans desc="Aktifleştir">10723</Trans>
                      </button>
                    </td>
                  </tr> : null
              }
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { employee } = this.props;

    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">{employee.fullname}</td>
            <td className="showGrup">
              {employee.position ? employee.position.name : ""}
            </td>
            <td className="showGrup">{employee.emailAddress}</td>
            <td className="showGrup">{employee?.language?.label}</td>
            <td className="showGrup">
  {Number(employee?.organizationInfo) === 0 ? (
    <span
      className="iconmford fo-icon-hourglass-empty"
      style={{ fontSize: "22px", fontWeight: "bold", color: "#ff7f00" }}
    />
  ) : (
    <span
      className="iconmford fo-icon-check"
      style={{ fontSize: "22px", fontWeight: "bold", color: "#2d96cd" }}
    />
  )}
</td> 
            <td className="showGrup" >
              <button style={{ display: this.props.page_type ? "block" : "none" }}
                className="btn-action btn-blue"
                onClick={() => this.openPositionChangeModal(employee)}
              >
                <Trans desc="Pozisyon Değişimi">10563</Trans>
              </button>
            </td>
            <td className="showGrup" >
              <button style={{ display: this.props.page_type ? "block" : "none" }}
                className="btn-action btn-orange"
                onClick={() => this.openCompanyTransferModal(employee)}
              >
                <Trans desc="Bayi Değişimi">
                  employeemanagement_company-transfer
                </Trans>
              </button>
            </td>
            <td className="showGrup" >
              <button style={{ display: this.props.page_type ? "block" : "none" }}
                className="btn-action btn-red"
                onClick={() => this.openJobTerminationModal(employee)}
              >
                <Trans desc="İşten Çıkış">10564</Trans>
              </button>
            </td>
            <td className="showGrup">
              <button style={{ display: this.props.page_type ? "block" : "none" }}
                className="btn-action btn-green"
                onClick={() => this.openUpdateEmployeeModal(employee)}
              >
                <Trans desc="Düzenleme">10565</Trans>
              </button>
            </td>
            <td className="showGrup">
              {
                employee.exportAvailabilityCode?.value == 2 ?
                  <button style={{ display: this.props.page_type ? "block" : "none" }} className="btn-action btn-brown" onClick={() => this.openActivateEmployeeModal(employee)}>
                    <Trans desc="Aktifleştir">10723</Trans>
                  </button> : null
              }
            </td>

            <td className="showGrup">
              {
                this.props.page_type == false ?
                  <button className="btn-action btn-green" onClick={() => this.openReActivateEmployeeModal(employee)}>
                    <Trans desc="Reactive">reactive</Trans>
                  </button> : null
              }
            </td>


          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">{employee.fullname}</td>
            <td className="showGrup">
              {employee.position ? employee.position.name : ""}
            </td>
          </tr>
          {this.renderTabletModeDetail(employee)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getEmployees,
  getEmployee,
  showModal,
})(containsLongRunningProcess(requireAuth(Employee)));
